import { RootScopeEvents } from '../../../common/services/root-scope-types';
import { isDoctor } from '../../call/helpers';
import { AngularServices, getAngularService } from '../../core';
import * as localMedia from '../index';
export const toggleVideo = (isEnabled) => async (_, getState) => {
    const _isEnabled = isEnabled ?? !localMedia.selectors.hasVideo(getState());
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(_isEnabled
        ? RootScopeEvents.USER_ACTIONS.VIDEO_ENABLED
        : RootScopeEvents.USER_ACTIONS.VIDEO_DISABLED);
    const { activeProvider } = getAngularService(AngularServices.VideoProviderFactory);
    await activeProvider.togglePublishersVideo(_isEnabled);
    if (_isEnabled) {
        getAngularService(AngularServices.DowngradeCallStateService).turnOnVideo();
        const { phone } = getAngularService(AngularServices.ActiveComponents);
        if (Boolean(phone?.options?.audioOnly) && isDoctor()) {
            delete phone.options.audioOnly;
        }
    }
};
export const toggleAudio = (isEnabled) => async (_, getState) => {
    const _isEnabled = isEnabled ?? !localMedia.selectors.hasAudio(getState());
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(_isEnabled
        ? RootScopeEvents.USER_ACTIONS.UNMUTE
        : RootScopeEvents.USER_ACTIONS.MUTE);
    const { activeProvider } = getAngularService(AngularServices.VideoProviderFactory);
    await activeProvider.togglePublishersAudio(_isEnabled);
};
